import { createReducer, on } from '@ngrx/store';
import * as FilterActions from './filter.actions';
import { TableParamConfig } from '@markant-platform/shared/table/model';

export type FilterStorageState = TableParamConfig & { filterInitialized?: boolean };

export enum TableContext {
  ORGANIZATION_OVERVIEW = 'ORGANIZATION_OVERVIEW',
  ORGANIZATION_MEMBER_OVERVIEW = 'ORGANIZATION_MEMBER_OVERVIEW',
  ORGANIZATION_MEMBER_SELECT_TEMPLATE_USER = 'ORGANIZATION_MEMBER_SELECT_TEMPLATE_USER',
  ORGANIZATION_BOOKINGS_OVERVIEW = 'ORGANIZATION_BOOKINGS_OVERVIEW',
  SUB_ORGANIZATIONS_OVERVIEW = 'SUB_ORGANIZATIONS_OVERVIEW',
  PLATFORM_REQUESTS = 'PLATFORM_REQUESTS',
  USER_OVERVIEW = 'USER_OVERVIEW',
  CARTRIDGE_OVERVIEW = 'CARTRIDGE_OVERVIEW',
  CARTRIDGE_MEMBER_OVERVIEW = 'CARTRIDGE_MEMBER_OVERVIEW',
  DOCUMENT_OVERVIEW = 'DOCUMENT_OVERVIEW',
  ROLE_OVERVIEW = 'ROLE_OVERVIEW',
  GROUP_ASSIGNMENT = 'GROUP_ASSIGNMENT',
  BOOKING_REQUESTS = 'BOOKING_REQUESTS',
}

export const initialFilter: Record<string, FilterStorageState> = {};

export const filterReducer = createReducer(
  initialFilter,
  on(FilterActions.resetFilter, (state, { key, defaultFilter = {} }) =>
    updateOne(state, key, {
      activeFilter: defaultFilter,
      searchQuery: '',
      page: { index: 1, size: 25 },
      filterInitialized: true,
    })
  ),
  on(FilterActions.setFilter, (state, { key, filter }) => updateOne(state, key, filter)),
  on(FilterActions.initHiddenColumnsSuccess, (state, { hiddenColumnsConfig }) => {
    const newState = { ...state };

    (<TableContext[]>Object.keys(hiddenColumnsConfig)).forEach(persistedTableContext => {
      if (Object.keys(state).includes(persistedTableContext)) {
        newState[persistedTableContext] = {
          ...state[persistedTableContext],
          hiddenColumns: hiddenColumnsConfig[persistedTableContext],
        };
      } else {
        newState[persistedTableContext] = {
          activeFilter: {},
          searchQuery: '',
          page: { index: 1, size: 25 },
          filterInitialized: false,
          hiddenColumns: hiddenColumnsConfig[persistedTableContext],
        };
      }
    });

    return newState;
  }),
  on(FilterActions.updateHiddenColumnsSuccess, (state, { tableContext, hiddenColumns }) => {
    return updateOne(state, tableContext, { hiddenColumns } as FilterStorageState);
  })
);

export function updateOne(
  state: Record<string, FilterStorageState>,
  key: TableContext,
  value: FilterStorageState
): Record<string, FilterStorageState> {
  return { ...state, [key]: { ...state[key], ...value } };
}
